import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { config, externalPaths } from "@config";

@Component({
	selector: "tax-offline-info-legacy-ui",
	templateUrl: "./tax-offline-info-legacy.component.html",
	styleUrls: ["./tax-offline-info-legacy.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TaxOfflineInfoLegacyUIComponent implements OnInit {
	@Input() showLink = false;
	@Input() walletName = "";

	link = "";

	ngOnInit(): void {
		const language: string = TranslationService.getLanguageIsoCode() === "de" ? "de" : "en-us";
		this.link = `${config.helpcenterUrl}hc/${language}/articles/${externalPaths.taxes.hdLink}`;
	}
}
